import { Icon } from '../../../../layout/Icon.jsx';

export function Drawer({ open, title, children, onClose, width = 480, footer }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50"
      style={{ background: 'rgba(0,0,0,.45)' }}
    >
      <div
        className="absolute top-0 bottom-0 bg-white border-l border-line shadow-card flex flex-col"
        style={{ width, insetInlineStart: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-h">
          <h3 className="text-[15px] font-bold flex-1">{title}</h3>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-[18px] space-y-3">{children}</div>
        {footer ? <div className="card-h border-b-0 border-t flex justify-end gap-2">{footer}</div> : null}
      </div>
    </div>
  );
}
